import React from "react";
import ReactTable from "react-table";
import find from "lodash/find";
import moment from "moment";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function DNDExpirationUsersGrid(props)
{
    const columns = [
		{
			id: "email",
			Header: "Email ID",
			accessor: "email",
		},
		{
			id: "first_name",
			Header: "First Name",
			accessor: "first_name",
            style: { 'whiteSpace': 'unset' },
		},
		{
			id: "last_name",
			Header: "Last Name",
			accessor: "last_name",
            style: { 'whiteSpace': 'unset' },
		},
		{
			id: "mobile_number",
			Header: "Mobile No",
			accessor: "mobile_number",
		},
    ];

    return (
            <ReactTable
                minRows={0}
                data={props.data || []}
                columns={columns}
                pageSize={props.data.length}
                sortable={false}
                showPagination={false}
                style={{overflowY: "initial",height: "530px"}}
                className="-striped hide-scrollbar"
            />
    )
}